export const getEntityId = (entity) =>
  entity?.id || entity?._id || entity?.storeId || entity?.employeeId || entity?.userId;

export const getEntityName = (entity) =>
  entity?.name ||
  entity?.fullName ||
  entity?.storeName ||
  entity?.fantasyName ||
  entity?.email ||
  entity?.login ||
  "-";

export const getUserDescription = (user) =>
  user?.email || user?.role || user?.employeeType || user?.group?.name || "";

export const filterEntities = (items, filter) => {
  const list = Array.isArray(items) ? items : [];
  const normalizedFilter = filter.trim().toLowerCase();

  if (!normalizedFilter) return list;

  return list.filter((item) => {
    const name = getEntityName(item).toLowerCase();
    const description = getUserDescription(item).toLowerCase();

    return name.includes(normalizedFilter) || description.includes(normalizedFilter);
  });
};
